import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Button = ({
    className = '',
    onClick = f => f,
    disabled = false,
    children
}) => {
    return (
        <button
            className={classNames('Button', className, { disabled: disabled })}
            onClick={(e) => !disabled && onClick(e)}
            disabled={disabled}
        >
            {children}
        </button>
    );
}

Button.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
};

export default Button;